import axios from 'axios'
import Properties from '../components/Properties'
// import { GetPrefixUniversity } from './AppSettings'
import { AppSetting , AppProperties, GetAPPURL } from '../common/functions';

var axiosClient = null;


//Create a Funtion to Initialize Axios with Proper Header
var initAxios = function()
{
  /**
 * Create an Axios Client with defaults
 */
  const appURL = GetAPPURL()
// let appProperties = new Properties();
if(appURL){ 
  const client = axios.create({
    baseURL: appURL,
    json: true
  });
  
  axiosClient =  client;
}else{
  setTimeout(() => {
    initAxios();
  },5000)
}
}

/**
 * ApiRequestService Wrapper with default success/error actions
 */
const ApiRequestService = function(options) {
  const appSetting = AppSetting();
  const appProperties = AppProperties();
  if(axiosClient == null ){
    initAxios();
  }

  const onSuccess = function(response) {
    console.debug('Request Successful!', response);
    return response;
  }

  const onError = function(error) {
    console.error('Request Failed:');

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      console.error('Status:',  error.response.status);
      console.error('Data:',    error.response.data);
      console.error('Headers:', error.response.headers);
    } else {
      // Something else happened while setting up the request
      // triggered the error
      
      console.error('Error Message:', error.message);
      let loginAttempt = localStorage.getItem('loginAttempt');
      if(loginAttempt < 5)
      {
        localStorage.setItem('loginAttempt', loginAttempt+1);
        //Do a Redirect
        window.location = appProperties.appURL
      }
        
    }

    return Promise.reject(error.response || error.message);
  }
  axiosClient.interceptors.request.use((request) =>{
    
    //Add Headers Here
    if(localStorage.getItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'token')){
      request.headers['Authorization'] = 'Token '+localStorage.getItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'token');
    }
    request.headers['content-type'] =  'application/json';
    
    return request;
    });
  axiosClient.interceptors.response.use((res) =>{

    //Validate Result Before Passing over to Controller
      
      if(res !== null && res !== undefined)
            {
                if(res.status !== undefined && res.status === 200)
                {
                        return res;   
                }else
                {
                    console.error('Server Returned Error -',res.status);
                    
                }
            }else
            {
              console.error('Server Returned Empty Response');
            }
        return Promise.reject(res);
    }, 
    (error) => 
    { 
     
      
      if (error.config && error.response && error.response.status === 401 && appProperties.enableLogin) 
      {
         //return new Promise(resolve=>);
         
         return new Promise(resolve =>{axiosClient({
          method: 'post',
          url: '/login'
        }).then((token) => {
         
          localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'token',token.data.authtoken)
          localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'GivenName',token.data.GivenName)
          localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'UnixEpoch',token.data.UnixEpoch)
          localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'emailid',token.data.emailid)
          localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'OSUID',token.data.USER_NAME)
          localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'role',token.data.role)
          
          
          
          
          
          error.config.headers.Authorization = 'Token '+ token.data.authtoken
         
          
          return resolve(axios.request(error.config));
         }).catch((error) => {
          
           if (error.response) {
             // Request was made but server responded with something
             // other than 2xx
             console.log("Adding Token Failed: ");
             console.error('Status:',  error.response.status);
             console.error('Data:',    error.response.data);
             console.error('Headers:', error.response.headers);

           }
          }) 
        });
      }

      return Promise.reject(error);
    }
);

  return axiosClient(options)
            .then(onSuccess)
            .catch(onError);
}






export default ApiRequestService;